"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DummyDataSource_1 = require("./DummyDataSource");
var DummyAdapter = /** @class */ (function () {
    // Intentional any
    function DummyAdapter(data, success, dataSource) {
        if (success === void 0) { success = true; }
        if (dataSource === void 0) { dataSource = null; }
        this.data = data;
        this.success = success;
        this.dataSource = dataSource;
    }
    DummyAdapter.prototype.createDataSource = function (_afm) {
        return this.dataSource
            ? Promise.resolve(this.dataSource)
            : Promise.resolve(new DummyDataSource_1.DummyDataSource(this.data, this.success));
    };
    return DummyAdapter;
}());
exports.DummyAdapter = DummyAdapter;
